import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'

import { userAdministrationClient } from '@/api'
import { useCurrentUser } from '@/hooks'

const BASE_QUERY_KEY = userAdministrationClient.QUERY_KEY

export const useGuestUsers = () => {
  const { isSuperAdmin } = useCurrentUser()
  const queryClient = useQueryClient()
  const { showSuccess } = useToast()

  const getGuestUsersQuery = useQuery({
    queryKey: BASE_QUERY_KEY,
    queryFn: userAdministrationClient.getGuestUsers,
    enabled: isSuperAdmin
  })

  const syncWithVeracityMutation = useMutation({
    mutationFn: userAdministrationClient.syncGuestUsersWithVeracity,
    onSuccess: async () => {
      showSuccess('Users synchronization succeed')
      await queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
  })

  const removeUserMutation = useMutation({
    mutationFn: userAdministrationClient.removeUser,
    onSuccess: async () => {
      showSuccess('User successfully removed')
      await queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
  })

  const attachToOrganizationMutation = useMutation({
    mutationFn: userAdministrationClient.attachToOrganization,
    onSuccess: async () => {
      showSuccess('User successfully attached to organization')
      await queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
  })

  return {
    guestUsers: getGuestUsersQuery.data,
    syncWithVeracity: syncWithVeracityMutation.mutate,
    removeUser: removeUserMutation.mutate,
    attachToOrganization: attachToOrganizationMutation.mutate,
    isInProgress:
      getGuestUsersQuery.isFetching ||
      syncWithVeracityMutation.isPending ||
      removeUserMutation.isPending ||
      attachToOrganizationMutation.isPending
  }
}
